<div class="ui-select">
  @if (label()) {
    <label class="ui-select__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-select__required">*</span>
      }
    </label>
  }

  @if (multiple()) {
    <select
      class="ui-select__control ui-select__control--multiple"
      [id]="id() || null"
      [disabled]="disabled()"
      [multiple]="true"
      (change)="onMultiValueChange(multiControl.options)"
      #multiControl
    >
      @for (option of options(); track option.value) {
        <option
          [value]="option.value"
          [disabled]="option.disabled ?? false"
          [selected]="values().includes(option.value)"
        >
          {{ option.label | uiLabelTranslate }}
        </option>
      }
    </select>
  } @else {
    <select
      class="ui-select__control"
      [id]="id() || null"
      [disabled]="disabled()"
      [value]="value()"
      (change)="onValueChange(controlValue.value)"
      #controlValue
    >
      @if (!required()) {
        <option value="">{{ placeholder() | uiLabelTranslate }}</option>
      }

      @for (option of options(); track option.value) {
        <option [value]="option.value" [disabled]="option.disabled ?? false">
          {{ option.label | uiLabelTranslate }}
        </option>
      }
    </select>
  }

  @if (error()) {
    <p class="ui-select__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-select__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
